import type { FilterChip } from "../../types";
import { defaultPromotionDateSlice, type PromotionDateSlice } from "./slice";
import { OPERATOR_LABELS } from "./operators";

export function getChips(
  slice: PromotionDateSlice,
  setSlice: (slice: PromotionDateSlice) => void
): FilterChip[] {
  if (!slice.date) return [];

  return [
    {
      id: "promotionDate",
      label: `Promotion date ${OPERATOR_LABELS[slice.operator].toLowerCase()} ${slice.date}`,
      filterKey: "promotionDate",
      onRemove: () => setSlice(defaultPromotionDateSlice),
    },
  ];
}

export function getCount(slice: PromotionDateSlice): number {
  return slice.date ? 1 : 0;
}
